export default "__VITE_ASSET__CqgHwcS3__"